// tslint:disable: deprecation
// tslint:disable: directive-selector
// First version based on https://stackoverflow.com/a/41253897/6813271
import {
    Directive, ElementRef, Input, Output, EventEmitter, SimpleChanges, OnChanges, HostListener
} from "@angular/core";
import { NgToolsService } from "../../ng-util/ng-tools.service";

@Directive({
    selector: "[contenteditableModel]"
})
export class ContentEditableDirective implements OnChanges {
    /** Model */
    @Input() contenteditableModel: string;
    @Output() contenteditableModelChange: EventEmitter<string> = new EventEmitter();
    @Output() onblur: EventEmitter<null> = new EventEmitter();

    constructor(private elRef: ElementRef, private toolsSvc: NgToolsService) {
        const _this = this;
        elRef.nativeElement.addEventListener("focus", function () {
            this.classList.add("is-focused");
        });

        elRef.nativeElement.addEventListener("blur", function () {
            this.classList.remove("is-focused");
            _this.onblur.emit(this.contenteditableModel);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["contenteditableModel"]) {
            // On init: if contenteditableModel is empty, read from DOM in case the element has content
            if (changes["contenteditableModel"].isFirstChange() && !this.contenteditableModel) {
                this.onInput();
            }
            this.refreshView();
        }
    }

    @HostListener("input") // input event would be sufficient, but isn't supported by IE
    @HostListener("blur")  // additional fallback
    @HostListener("keyup") onInput() {
        let value = this.elRef.nativeElement.innerText;
        const patt2 = new RegExp("<div>", "g");
        const patt3 = new RegExp("</div>", "g");
        const patt4 = new RegExp("<br>", "g");
        const patt5 = new RegExp("\n", "g");
        value = value.replace(patt2, "\n").replace(patt3, "").replace(patt4, "").replace(patt5, "");

        this.contenteditableModelChange.emit(value);
    }

    @HostListener("keydown", ["$event"]) onKeyDown(event) {
        const e = <KeyboardEvent>event;

        if ([46, 8, 9, 27, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        if (e.keyCode === 13) { // No line breaks
            e.preventDefault();
        }
    }

    @HostListener("paste") onPaste() {
        this.onInput();
        // For text-only contenteditable, remove pasted HTML.
        // 1 tick wait is required for DOM update
        this.toolsSvc.setTimeout(() => {
            if (this.elRef.nativeElement.innerHTML !== this.elRef.nativeElement.innerText) {
                this.elRef.nativeElement.innerHTML = this.elRef.nativeElement.innerText;
            }
        });
    }

    private refreshView() {
        const newContent = this.contenteditableModel;
        // Only refresh if content changed to avoid cursor loss
        // (as ngOnChanges can be triggered an additional time by onInput())
        if (newContent !== this.elRef.nativeElement.innerText) {
            this.elRef.nativeElement.innerText = newContent;
        }
    }
}
